import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Header } from '../components/site/Header';
import { Footer } from '../components/site/Footer';

export default function NotFound() {
  useEffect(() => {
    document.title = 'Seite nicht gefunden (404) – FlensFitness';
    const set = (key, name, content) => {
      let node = document.head.querySelector(`meta[${key}="${name}"]`);
      if (!node) { node = document.createElement('meta'); node.setAttribute(key, name); document.head.appendChild(node); }
      node.setAttribute('content', content);
    };
    set('name', 'robots', 'noindex');
    set('name', 'description', 'Diese Seite gibt es bei FlensFitness nicht. Zur Startseite mit Kursen, Kursplan und Probetraining.');
    set('name', 'prerender-status-code', '404');
    document.head.querySelector('link[rel="canonical"]')?.remove();
    return () => { document.head.querySelector('meta[name="robots"]')?.remove(); document.head.querySelector('meta[name="prerender-status-code"]')?.remove(); };
  }, []);
  return <div data-testid="not-found-page">
    <Header />
    <main className="max-w-3xl mx-auto px-5 pt-40 pb-24">
      <p className="eyebrow mb-5">404</p>
      <h1 className="h-display text-4xl sm:text-5xl">Seite nicht gefunden</h1>
      <p className="muted mt-6">Diese Adresse gibt es bei uns nicht (mehr). Hier geht es weiter:</p>
      <nav aria-label="Weiter zu" className="mt-8 flex flex-wrap gap-3">
        <Link to="/" data-testid="not-found-home-link" className="btn-primary">Startseite</Link>
        <Link to="/kurse" data-testid="not-found-kurse-link" className="btn-ghost">Kurse</Link>
        <Link to="/preise" data-testid="not-found-preise-link" className="btn-ghost">Preise</Link>
        <Link to="/probetraining-flensburg" data-testid="not-found-probetraining-link" className="btn-ghost">Probetraining</Link>
      </nav>
    </main>
    <Footer />
  </div>;
}
